import { Reveal, SectionLabel } from "@/components/Reveal";

const IMG_MAIN = "https://images.unsplash.com/photo-1577701122197-c9607038bd90";
const IMG_SECOND = "https://images.pexels.com/photos/37612863/pexels-photo-37612863.jpeg";

const STATS = [
  ["Tbilisi", "Home base"],
  ["All regions", "Partner network"],
  ["B2B first", "Our model"],
];

export default function AboutGeorgia() {
  return (
    <section id="georgia" data-testid="georgia-section" className="relative overflow-hidden py-24 md:py-36">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-16 px-6 md:px-12 lg:grid-cols-2 lg:gap-20">
        <div className="relative">
          <Reveal>
            <div className="relative overflow-hidden border border-[#E2E8F0] shadow-sm">
              <img
                src={IMG_MAIN}
                alt="Gergeti Trinity Church beneath Mount Kazbek"
                loading="lazy"
                data-testid="georgia-image-main"
                className="aspect-[4/5] w-full object-cover transition-transform duration-[1200ms] hover:scale-105"
              />
            </div>
          </Reveal>
          <Reveal delay={0.2} className="absolute -bottom-10 -right-4 hidden w-1/2 md:block lg:-right-10">
            <div className="overflow-hidden border border-[#184167]/30 shadow-[0_8px_32px_rgba(7,21,38,0.18)]">
              <img
                src={IMG_SECOND}
                alt="Snow-capped Caucasus mountains"
                loading="lazy"
                data-testid="georgia-image-secondary"
                className="aspect-[4/3] w-full object-cover"
              />
            </div>
          </Reveal>
        </div>

        <div>
          <Reveal>
            <SectionLabel testId="georgia-label">Why Georgia, why us</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2
              data-testid="georgia-heading"
              className="mt-6 font-display text-3xl font-light leading-tight tracking-tight text-[#071526] md:text-5xl"
            >
              Strong local expertise. Reliable partners.{" "}
              <span className="italic text-[#184167]">One seamless experience.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p
              data-testid="georgia-copy"
              className="mt-8 max-w-xl text-sm font-light leading-relaxed tracking-wide text-[#5C6B7C] md:text-base"
            >
              With strong local expertise and reliable partners across Georgia, we help
              your clients enjoy seamless travel experiences while creating value for
              your business. From the cobbled streets of old Tbilisi to the high
              Caucasus, our on-ground team handles every detail — so you can promise
              more, and deliver it.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-12 grid grid-cols-3 gap-6 border-t border-[#E2E8F0] pt-8" data-testid="georgia-stats">
              {STATS.map(([big, small]) => (
                <div key={small}>
                  <div className="font-display text-xl font-light text-[#184167] md:text-2xl">{big}</div>
                  <div className="mt-1 text-[10px] uppercase tracking-[0.25em] text-[#5C6B7C]">{small}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
